import { Drawer } from 'antd';
import InvoiceDetailComponent from '../../components/invoices/InvoiceDetailComponent';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { useEffect, useState } from 'react';
import {
  InvoiceApprovalType,
  changeInvoicePriceAsync,
  createInvoiceCommentAsync,
  createInvoicePaymentAsync,
  createSubInvoiceAsync,
  excludeSubInvoiceAsync,
  getInvoiceDetailAsync,
  updateInvoiceStatusAsync,
} from '../../modules/invoices';
import InvoiceEditDrawer from './InvoiceEditDrawer';
import saveAs from 'file-saver';
import CreateInvoiceCommentModal from '../../components/invoices/CreateInvoiceCommentModal';
import SubInvoiceCreateModal from '../../components/invoices/SubInvoiceCreateModal';
import PDFViewModal2 from '../../components/expenses/PDFViewModal2';
import InvoiceDeclinedModal from '../../components/invoices/InvoiceDeclinedModal';
import CreateInvoicePaymentModal from '../../components/invoices/CreateInvoicePaymentModal';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import InvoiceCancelModal from '../../components/invoices/InvoiceCancelModal';
import ChangeInvoicePriceModal from '../../components/invoices/ChangeInvoicePriceModal';

interface InvoiceDetailDrawerProps {
  config: any;
  visible: boolean;
  onClose: () => void;
}

function InvoiceDetailDrawer({
  config,
  visible,
  onClose,
}: InvoiceDetailDrawerProps) {
  const invoice = useSelector(
    (state: RootState) => state.invoices.invoice.data,
  );
  const user = useSelector((state: RootState) => state.auth.auth.data);
  // const [invoice, setInvoice] = useState<Invoice>();
  const [visibleEditlDrawer, setVisibleEditDrawer] = useState<boolean>(false);
  const [editDrawerConfig, setEditDrawerConfig] = useState<any>();
  const [visibleInvoiceCreateModal, setVisibleInvoiceCreateModal] =
    useState(false);

  const [
    visibleCreateInvoicePaymentModal,
    setVisibleCreateInvoicePaymentModal,
  ] = useState(false);

  const [visibleChangeInvoicePriceModal, setVisibleChangeInvoicePriceModal] =
    useState(false);

  // const [visibleSubInvoiceDetailDrawer, setVisibleSubInvoiceDetailDrawer] =
  //   useState<boolean>(false);
  // const [subInvoiceDetailDrawerConfig, setSubInvoiceDetailDrawerConfig] =
  //   useState<any>();

  const [visibleSubInvoiceCreateModal, setVisibleSubInvoiceCreateModal] =
    useState<boolean>(false);
  const [visibleInvoiceDeclinedModal, setVisibleInvoiceDeclinedModal] =
    useState<boolean>(false);
  const [visibleInvoiceCancelModal, setVisibleInvoiceCancelModal] =
    useState<boolean>(false);

  const [pdfFile, setPdfFile] = useState<any>();

  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (invoices === null) return;
  //   if (config === null) return;
  //   console.log(invoices);
  //   setInvoice(invoices.find((e) => e.id === +config.invoiceId));
  // }, [config, invoices]);

  useEffect(() => {
    dispatch(
      getInvoiceDetailAsync.request({
        enterpriseId: config.enterpriseId,
        invoiceId: config.invoiceId,
      }),
    );
  }, [config, dispatch]);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    if (queryParams.has('invoiceId')) {
      queryParams.delete('invoiceId');
      history.replace({
        search: queryParams.toString(),
      });
    }
  }, [history, location]);

  const moveToEditPage = () => {
    setEditDrawerConfig({ ...config });
    setVisibleEditDrawer(true);
  };

  const onCloseEditDrawer = () => {
    setVisibleEditDrawer(false);
  };

  const onOpenCreateInvoiceCommentModal = () =>
    setVisibleInvoiceCreateModal(true);
  const onCloseCreateInvoiceCommentModal = () =>
    setVisibleInvoiceCreateModal(false);
  const onCreateInvoiceComment = (value: any) => {
    dispatch(
      createInvoiceCommentAsync.request({
        ...config,
        data: {
          ...value,
        },
      }),
    );
    setVisibleInvoiceCreateModal(false);
  };

  const onCreateInvoicePayment = (value: any) => {
    dispatch(
      createInvoicePaymentAsync.request({
        ...config,
        data: {
          ...value,
          paymentDate: moment(value.paymentDate).format('YYYY-MM-DD'),
        },
      }),
    );
    setVisibleCreateInvoicePaymentModal(false);
  };

  const onCloseInvoicePaymentModal = () =>
    setVisibleCreateInvoicePaymentModal(false);

  const onOpenCreateInvoicePaymentModal = () =>
    setVisibleCreateInvoicePaymentModal(true);

  const _downloadReceipt = () => {
    saveAs(pdfFile.url, `${pdfFile.name}`);
    // saveAs(
    //   invoice?.file[0].url,
    //   `${invoice?.billingDate}_${invoice?.vendor.application.general.name}.pdf`,
    // );
  };

  const openSubInvoiceDetailDrawer = (invoiceId: string) => {
    // setSubInvoiceDetailDrawerConfig({ ...config, invoice, invoiceId });
    // setVisibleSubInvoiceDetailDrawer(true);
  };
  const openSubInvoiceCreateModal = () => {
    setVisibleSubInvoiceCreateModal(true);
  };
  const excludeSubInvoice = (subInvoiceId: string) => {
    dispatch(
      excludeSubInvoiceAsync.request({
        ...config,
        subInvoiceId,
        // data: {
        //   idList: [+invoiceId],
        // },
      }),
    );
  };

  // const onCloseSubInvoiceDetailDrawer = () => {
  //   setVisibleSubInvoiceDetailDrawer(false);
  // };

  const onCreateSubInvoiceCreateModal = (idList: number[]) => {
    dispatch(
      createSubInvoiceAsync.request({
        ...config,
        data: {
          idList,
        },
      }),
    );
    setVisibleSubInvoiceCreateModal(false);
  };

  const onCancelSubInvoiceCreateModal = () => {
    setVisibleSubInvoiceCreateModal(false);
  };

  const updateInvoiceStatus = (approvalType: InvoiceApprovalType) => {
    if (approvalType === InvoiceApprovalType.DECLINE_APPROVAL) {
      setVisibleInvoiceDeclinedModal(true);
      return;
    }

    if (approvalType === InvoiceApprovalType.CANCEL_APPROVAL) {
      setVisibleInvoiceCancelModal(true);
      return;
    }

    dispatch(
      updateInvoiceStatusAsync.request({
        ...config,
        approvalType,
        invoice: {},
      }),
    );
  };

  const onCreateInvoiceDeclinedModal = (data: any) => {
    dispatch(
      updateInvoiceStatusAsync.request({
        ...config,
        approvalType: InvoiceApprovalType.DECLINE_APPROVAL,
        invoice: {
          ...data,
        },
      }),
    );
    setVisibleInvoiceDeclinedModal(false);
  };

  const onCancelInvoiceDeclinedModal = () => {
    setVisibleInvoiceDeclinedModal(false);
  };

  const onCreateInvoiceCancelModal = (data: any) => {
    dispatch(
      updateInvoiceStatusAsync.request({
        ...config,
        approvalType: InvoiceApprovalType.CANCEL_APPROVAL,
        invoice: {
          ...data,
        },
      }),
    );
    setVisibleInvoiceCancelModal(false);
  };

  const onCancelInvoiceCancelModal = () => {
    setVisibleInvoiceCancelModal(false);
  };

  const openPdfFile = (file: any) => {
    setPdfFile(file);
  };

  const changeInvoicePrice = (data: any) => {
    dispatch(
      changeInvoicePriceAsync.request({
        ...config,
        data: {
          ...data,
        },
      }),
    );
    setVisibleChangeInvoicePriceModal(false);
  };

  return (
    <>
      {invoice && (
        <Drawer
          width={900}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
        >
          {visible && user && (
            <InvoiceDetailComponent
              invoice={invoice}
              user={user}
              isEnterpriseLevel={config.isEnterpriseLevel}
              moveToEditPage={moveToEditPage}
              onOpenCreateInvoiceCommentModal={onOpenCreateInvoiceCommentModal}
              onOpenCreateInvoicePaymentModal={onOpenCreateInvoicePaymentModal}
              openSubInvoiceDetailDrawer={openSubInvoiceDetailDrawer}
              openSubInvoiceCreateModal={openSubInvoiceCreateModal}
              excludeSubInvoice={excludeSubInvoice}
              updateInvoiceStatus={updateInvoiceStatus}
              openPdfFile={openPdfFile}
              openChangeInvoicePriceModal={() =>
                setVisibleChangeInvoicePriceModal(true)
              }
            />
          )}
        </Drawer>
      )}
      {editDrawerConfig && invoice && (
        <InvoiceEditDrawer
          config={editDrawerConfig}
          invoice={invoice}
          visible={visibleEditlDrawer}
          onClose={onCloseEditDrawer}
        />
      )}
      {pdfFile && (
        <PDFViewModal2
          visible={!!pdfFile}
          url={pdfFile.url}
          onCancel={() => setPdfFile(null)}
          onDownload={_downloadReceipt}
        />
      )}
      {visibleInvoiceCreateModal && (
        <CreateInvoiceCommentModal
          visible={visibleInvoiceCreateModal}
          onCreate={onCreateInvoiceComment}
          onCancel={onCloseCreateInvoiceCommentModal}
        />
      )}
      {visibleCreateInvoicePaymentModal && invoice && (
        <CreateInvoicePaymentModal
          visible={visibleCreateInvoicePaymentModal}
          invoice={invoice}
          onCreate={onCreateInvoicePayment}
          onCancel={onCloseInvoicePaymentModal}
        />
      )}
      {visibleChangeInvoicePriceModal && invoice && (
        <ChangeInvoicePriceModal
          visible={visibleChangeInvoicePriceModal}
          invoice={invoice}
          onCreate={changeInvoicePrice}
          onCancel={() => setVisibleChangeInvoicePriceModal(false)}
        />
      )}
      {visibleSubInvoiceCreateModal && invoice && (
        <SubInvoiceCreateModal
          visible={visibleSubInvoiceCreateModal}
          enterpriseId={config.enterpriseId}
          invoice={invoice}
          onCreate={onCreateSubInvoiceCreateModal}
          onCancel={onCancelSubInvoiceCreateModal}
        />
      )}

      {visibleInvoiceDeclinedModal && (
        <InvoiceDeclinedModal
          visible={visibleInvoiceDeclinedModal}
          onCeate={onCreateInvoiceDeclinedModal}
          onCancel={onCancelInvoiceDeclinedModal}
        />
      )}
      {visibleInvoiceCancelModal && (
        <InvoiceCancelModal
          visible={visibleInvoiceCancelModal}
          onCeate={onCreateInvoiceCancelModal}
          onCancel={onCancelInvoiceCancelModal}
        />
      )}
    </>
  );
}

export default InvoiceDetailDrawer;
